// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CashflowsImport_IntegrationCashflowFragment = { __typename?: 'IntegrationCashflow', id: string, name: string, ownerName?: string | null, externalKind: Types.IntegrationCashflowExternalKind, value?: CurrencyUSD | null, growthRate?: Percent | null, startDate?: Time | null, endDate?: Time | null };

export type CashflowsImportQueryVariables = Types.Exact<{
  householdsLike: Types.HouseholdWhereInput;
  integrationClientKind?: Types.InputMaybe<Types.IntegrationClientKind>;
}>;


export type CashflowsImportQuery = { __typename?: 'Query', integrationCashflows: { __typename?: 'IntegrationCashflowConnection', edges?: Array<{ __typename?: 'IntegrationCashflowEdge', node?: (
        { __typename?: 'IntegrationCashflow' }
        & CashflowsImport_IntegrationCashflowFragment
      ) | null } | null> | null } };

export type CashflowsImportInferNameMatchQueryVariables = Types.Exact<{
  input: Types.InferNameMatchInput;
}>;


export type CashflowsImportInferNameMatchQuery = { __typename?: 'Query', inferNameMatch?: string | null };

export type CreateImportedCashflowMutationVariables = Types.Exact<{
  input: Types.AugmentedCreateCashflowInput;
}>;


export type CreateImportedCashflowMutation = { __typename?: 'Mutation', createCashflow: { __typename?: 'Cashflow', id: string } };

export const Operations = {
  Query: {
    CashflowsImport: 'CashflowsImport' as const,
    CashflowsImportInferNameMatch: 'CashflowsImportInferNameMatch' as const
  },
  Mutation: {
    CreateImportedCashflow: 'CreateImportedCashflow' as const
  },
  Fragment: {
    CashflowsImport_IntegrationCashflow: 'CashflowsImport_IntegrationCashflow' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const CashflowsImport_IntegrationCashflowFragmentDoc = gql`
    fragment CashflowsImport_IntegrationCashflow on IntegrationCashflow {
  id
  name
  ownerName
  externalKind
  value
  growthRate
  startDate
  endDate
}
    `;
export const CashflowsImportDocument = gql`
    query CashflowsImport($householdsLike: HouseholdWhereInput!, $integrationClientKind: IntegrationClientKind) {
  integrationCashflows(
    where: {and: [{hasCashflows: false}, {hasIntegrationClientWith: [{kind: $integrationClientKind}, {hasClientHouseholdsWith: [$householdsLike]}]}]}
    orderBy: {direction: DESC, field: created_at}
  ) {
    edges {
      node {
        ...CashflowsImport_IntegrationCashflow
      }
    }
  }
}
    ${CashflowsImport_IntegrationCashflowFragmentDoc}`;

/**
 * __useCashflowsImportQuery__
 *
 * To run a query within a React component, call `useCashflowsImportQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashflowsImportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashflowsImportQuery({
 *   variables: {
 *      householdsLike: // value for 'householdsLike'
 *      integrationClientKind: // value for 'integrationClientKind'
 *   },
 * });
 */
export function useCashflowsImportQuery(baseOptions: Apollo.QueryHookOptions<CashflowsImportQuery, CashflowsImportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CashflowsImportQuery, CashflowsImportQueryVariables>(CashflowsImportDocument, withFetchPolicyContext(options));
      }
export function useCashflowsImportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashflowsImportQuery, CashflowsImportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CashflowsImportQuery, CashflowsImportQueryVariables>(CashflowsImportDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useCashflowsImportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CashflowsImportQuery, CashflowsImportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CashflowsImportQuery, CashflowsImportQueryVariables>(CashflowsImportDocument, withFetchPolicyContext(options));
        }
export type CashflowsImportQueryHookResult = ReturnType<typeof useCashflowsImportQuery>;
export type CashflowsImportLazyQueryHookResult = ReturnType<typeof useCashflowsImportLazyQuery>;
export type CashflowsImportSuspenseQueryHookResult = ReturnType<typeof useCashflowsImportSuspenseQuery>;
export type CashflowsImportQueryResult = Apollo.QueryResult<CashflowsImportQuery, CashflowsImportQueryVariables>;
export const CashflowsImportInferNameMatchDocument = gql`
    query CashflowsImportInferNameMatch($input: InferNameMatchInput!) {
  inferNameMatch(input: $input)
}
    `;

/**
 * __useCashflowsImportInferNameMatchQuery__
 *
 * To run a query within a React component, call `useCashflowsImportInferNameMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashflowsImportInferNameMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashflowsImportInferNameMatchQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCashflowsImportInferNameMatchQuery(baseOptions: Apollo.QueryHookOptions<CashflowsImportInferNameMatchQuery, CashflowsImportInferNameMatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CashflowsImportInferNameMatchQuery, CashflowsImportInferNameMatchQueryVariables>(CashflowsImportInferNameMatchDocument, withFetchPolicyContext(options));
      }
export function useCashflowsImportInferNameMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashflowsImportInferNameMatchQuery, CashflowsImportInferNameMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CashflowsImportInferNameMatchQuery, CashflowsImportInferNameMatchQueryVariables>(CashflowsImportInferNameMatchDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useCashflowsImportInferNameMatchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CashflowsImportInferNameMatchQuery, CashflowsImportInferNameMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CashflowsImportInferNameMatchQuery, CashflowsImportInferNameMatchQueryVariables>(CashflowsImportInferNameMatchDocument, withFetchPolicyContext(options));
        }
export type CashflowsImportInferNameMatchQueryHookResult = ReturnType<typeof useCashflowsImportInferNameMatchQuery>;
export type CashflowsImportInferNameMatchLazyQueryHookResult = ReturnType<typeof useCashflowsImportInferNameMatchLazyQuery>;
export type CashflowsImportInferNameMatchSuspenseQueryHookResult = ReturnType<typeof useCashflowsImportInferNameMatchSuspenseQuery>;
export type CashflowsImportInferNameMatchQueryResult = Apollo.QueryResult<CashflowsImportInferNameMatchQuery, CashflowsImportInferNameMatchQueryVariables>;
export const CreateImportedCashflowDocument = gql`
    mutation CreateImportedCashflow($input: AugmentedCreateCashflowInput!) {
  createCashflow(input: $input) {
    id
  }
}
    `;
export type CreateImportedCashflowMutationFn = Apollo.MutationFunction<CreateImportedCashflowMutation, CreateImportedCashflowMutationVariables>;

/**
 * __useCreateImportedCashflowMutation__
 *
 * To run a mutation, you first call `useCreateImportedCashflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateImportedCashflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createImportedCashflowMutation, { data, loading, error }] = useCreateImportedCashflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateImportedCashflowMutation(baseOptions?: Apollo.MutationHookOptions<CreateImportedCashflowMutation, CreateImportedCashflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateImportedCashflowMutation, CreateImportedCashflowMutationVariables>(CreateImportedCashflowDocument, options);
      }
export type CreateImportedCashflowMutationHookResult = ReturnType<typeof useCreateImportedCashflowMutation>;
export type CreateImportedCashflowMutationResult = Apollo.MutationResult<CreateImportedCashflowMutation>;
export type CreateImportedCashflowMutationOptions = Apollo.BaseMutationOptions<CreateImportedCashflowMutation, CreateImportedCashflowMutationVariables>;